import { adminMutation } from "@/admin/utils/adminMutation.ts";
import { type ApiClient, getResponseData } from "@/modules/api/apiClient.ts";
import { atomFromStandardQueryOptions } from "@/utils/query/queryAtom.ts";
import { type QueryKey, queryOptions } from "@tanstack/react-query";
import type { BillingAccountInvoice, InvoiceStatusUpdateParam } from "@warrenio/api-spec/spec.oats.gen";
import { atomFamily } from "jotai-family";

interface Params {
    invoice_id: string;
}

function getQueryKey(params?: Params): QueryKey {
    return params == null ? ["payment/admin/invoices"] : ["payment/admin/invoices", params.invoice_id];
}

function getSingleQuery(apiClient: ApiClient, params: Params) {
    return queryOptions({
        queryKey: getQueryKey(params),
        queryFn: async ({ signal }): Promise<BillingAccountInvoice> => {
            const { invoice_id } = params;
            return getResponseData(
                await apiClient.GET("/payment/admin/invoices/{invoice_id}", {
                    signal,
                    params: { path: { invoice_id } },
                }),
            );
        },
    });
}

export const invoiceQueryAtom = atomFamily((invoice_id: string) =>
    atomFromStandardQueryOptions(getSingleQuery, { invoice_id }),
);

//#region Mutations
const entity = "Invoice";

export const updateInvoiceStatusMutation = adminMutation((apiClient) => ({
    entity,
    operation: "modify",
    requestFn: async ({ document_number, status }: { document_number: string; status: InvoiceStatusUpdateParam }) =>
        await apiClient.PUT("/payment/admin/invoice/status", {
            params: { query: { document_number: document_number, status } },
        }),
}));
//#endregion Mutations
